import { Route } from 'types/route.type';
import ScenarioPlanStepOverview from 'views/playground/features/scenario-planner-2.0/components/scenario-plan-step-overview';

export const routes: Route[] = [
  {
    path: '/playground/scenario-plan',
    component: ScenarioPlanStepOverview,
  },
];
